import { createSlice } from "@reduxjs/toolkit";

const counterSlice = createSlice({
    name: "counter",
    initialState: {
        messages: [],
        suggestionList: [],
        productPageMessages: [],
        botProduct: "",
        botLoader: false,
        userHandlerName: '',
        isNewConversation: "new",
        isAnswerCalling: false,
        addToCartObj: {},
        stopId: "",
        showSidePanel: false
    },
    reducers: {
        addMessages(state, action) {
            state.messages = action.payload
        },
        handleAnswerCalling(state, action) {
            state.isAnswerCalling = action.payload
        },
        addOrRemoveObjectForAddToCart(state, action) {
            state.addToCartObj = action.payload
        },
        setIsNewConversation(state, action) {
            state.isNewConversation = action.payload
        },
        setBotProduct(state, action) {
            state.botProduct = action.payload
        },
        addQuestion: (state: any, action) => {
            state.messages.push(action.payload)
        },
        updateQuestion: (state: any, action) => {
            const updatedMessage = action.payload;
            const index = state.messages.findIndex((message: { id: any; }) => message.id === updatedMessage.id);
            if (index !== -1) {
                state.messages[index] = updatedMessage;
            }
        },
        resetQuestion: (state) => {
            state.messages = []
        },
        setSuggestionList(state, action) {
            state.suggestionList = action.payload
        },
        handBotleLoader(state, action) {
            state.botLoader = action.payload;
        },
        addProductPageQuestion: (state: any, action) => {
            state.productPageMessages.push(action.payload)
        },
        updateProductPageQuestion: (state: any, action) => {
            const updatedMessage = action.payload;
            const index = state.productPageMessages.findIndex((message: { id: any; }) => message.id === updatedMessage.id);
            if (index !== -1) {
                state.productPageMessages[index] = updatedMessage;
            }
        },
        resetProductPageQuestion: (state) => {
            state.productPageMessages = []
        },
        setUserHandlerName(state, action) {
            state.userHandlerName = action.payload
        },
        setStopId(state, action) {
            state.stopId = action.payload
        },
        setShowSidePanel(state, action) {
            state.showSidePanel = action.payload
        },
    }
})

export const { setStopId, addMessages, setBotProduct, addQuestion, updateQuestion, handBotleLoader, handleAnswerCalling, addOrRemoveObjectForAddToCart, setIsNewConversation, resetQuestion, setSuggestionList, setUserHandlerName, resetProductPageQuestion, updateProductPageQuestion, addProductPageQuestion,setShowSidePanel } = counterSlice.actions;
export default counterSlice.reducer;